import { useState } from 'react'

import {
  DADATA_API_KEY,
  Organization,
  useOrganization,
} from '@builddocs/data-management'
import {
  Button,
  InnInput,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
} from '@builddocs/mui'
import { useToast } from '@builddocs/system'
import { Text, VisuallyHiddenInput } from '@chakra-ui/react'
import { CloudUpload } from '@mui/icons-material'
import { CircularProgress, Stack, Typography } from '@mui/material'
import axios, { AxiosError } from 'axios'
import formatISO from 'date-fns/formatISO'
import _ from 'lodash'
import * as XLSX from 'xlsx'

export const BAPIBAPIBEEPBEEP = axios.create({
  baseURL: '/api',
})

export const createOrgHardcoded = (
  organization: Organization,
  jwtToken: string,
) => {
  console.log('jwt', jwtToken)
  return BAPIBAPIBEEPBEEP.post('/organization', organization, {
    headers: {
      Authorization: `Bearer ${jwtToken}`, // Добавляем токен в заголовок
    },
  })
}

const ProcessUsers = () => {
  const [usersData, setUsersData] = useState<
    { password: string; username: string; inn: string }[]
  >([])
  const [currentRowIndex, setCurrentRowIndex] = useState(0)
  const [userSession, setUserSession] = useState(null)
  const [uploadedFile, setUploadedFile] = useState(null)
  const [progress, setProgress] = useState('')
  const [modalOpened, setModalOpened] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [loggedInUser, setLoggedInUser] = useState('')
  const [loggedInInn, setLoggedInInn] = useState('')
  const { toast } = useToast()
  const [organizationForm, setOrganizationForm] = useState({
    name: '',
    documentNumber: '',
    ogrnDate: '',
    ogrn: '',
    inn: '',
    kpp: '',
    legalAddress: {},
    physicalAddress: {},
  })
  const { organization } = useOrganization(loggedInInn)

  const handleFileSelection = event => {
    const file = event.target.files[0]

    if (file) {
      setUploadedFile(file)
      setProgress('Читаем Excel файл...')
      const reader = new FileReader()

      reader.onload = async e => {
        // @ts-expect-error затычка
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const sheetName = workbook.SheetNames[0]
        const sheet = workbook.Sheets[sheetName]
        const rows = XLSX.utils.sheet_to_json(sheet, { defval: '' })

        setUsersData(rows as any)
        setProgress('')
      }
      reader.readAsArrayBuffer(file)
    }
  }

  const generateOrganizationForUser = async (userSession, data) => {
    const {
      inn,
      kpp,
      sro,
      sroDate,
      sroIssuerName,
      sroIssuerInn,
      sroIssuerOgrn,
      sroEngineering,
      sroEngineeringDate,
      sroEngineeringInn,
      sroEngineeringName,
      sroEngineeringOgrn,
      phone,
      physicalAddress,
    } = data

    return createOrgHardcoded(
      {
        inn: kpp ? `${inn}-${kpp}` : inn,
        sro,
        sroDate: sroDate
          ? formatISO(new Date(sroDate), { representation: 'date' })
          : undefined,
        sroIssuerName,
        sroIssuerInn,
        sroIssuerOgrn,
        sroEngineering,
        sroEngineeringDate,
        sroEngineeringInn,
        sroEngineeringName,
        sroEngineeringOgrn,
        physicalAddress,
        phone,
      },
      userSession.jwtToken,
    )
  }

  const handleLogin = async () => {
    const currentRow = usersData[currentRowIndex]

    if (!currentRow) return

    const email = currentRow['Почта (Обязательно)']
    const password = currentRow['Пароль (Обязательно)']
    const inn = currentRow['ИНН']

    setProgress(`Логиним пользователя: ${email}...`)
    setIsLoading(true)
    try {
      const session = await BAPIBAPIBEEPBEEP.post(
        '/login',
        {
          username: email,
          password,
        },
        { headers: { 'Content-Type': 'application/json' } },
      ).then(response => response.data)

      setUserSession(session)
      setLoggedInUser(email)
      setLoggedInInn(inn)
      setProgress('Логин успешен. Нажмите "Продолжить".')
    } catch (err) {
      console.error('Ошибка логина:', err)
      setProgress('Ошибка логина. Перейдите к следующему пользователю.')
    } finally {
      setIsLoading(false)
    }
  }

  const handleContinue = async () => {
    if (!userSession || !organizationForm.inn) return

    try {
      setProgress(
        `Создаем организацию для ${usersData[currentRowIndex].username}...`,
      )
      await generateOrganizationForUser(userSession, organizationForm)
      setProgress('Организация успешно создана.')
      toast.success('Создали, движемся дальше')
    } catch (err) {
      const error = err as AxiosError

      toast.error(
        error?.response?.data?.message ??
          'Похоже организация уже существует. подробности в консоли и net запросе',
      )
      console.error('Ошибка создания организации:', err)
      setProgress('Ошибка создания организации.')
    } finally {
      setUserSession(null)
      setLoggedInUser('')
      setOrganizationForm({
        name: '',
        documentNumber: '',
        ogrnDate: '',
        ogrn: '',
        inn: '',
        kpp: '',
        legalAddress: {},
        physicalAddress: {},
      })
      setLoggedInInn('')
      setCurrentRowIndex(prev => prev + 1)
      setProgress('Переходим к следующему пользователю...')
    }
  }

  const handleSkip = () => {
    setProgress('Пропускаем текущего пользователя...')
    setUserSession(null)
    setLoggedInUser('')
    setLoggedInInn('')
    setCurrentRowIndex(prev => prev + 1)
    setProgress('')
  }

  const handleInnInput = response => {
    const {
      data: { address: address1, inn, kpp, ogrn, ogrn_date },
      value,
    } = response

    setOrganizationForm(prev => ({
      ...prev,
      name: value,
      documentNumber: ogrn,
      ogrnDate: ogrn_date
        ? new Date(ogrn_date).toISOString().split('T')[0]
        : '',
      ogrn,
      inn,
      kpp,
      legalAddress: {
        postalCode: address1.data.postal_code,
        countryIsoCode: address1.data.country_iso_code,
        country: address1.data.country,
        region: address1.data.region_with_type,
        area: address1.data.area_with_type,
        city: address1.data.city_with_type,
        street: address1.data.street_with_type,
        house: address1.data.house,
        office: address1.data.flat,
      },
    }))
  }

  return (
    <>
      <Button
        style={{ backgroundColor: 'purple', color: 'white' }}
        onClick={() => setModalOpened(true)}
      >
        Загрузить файл пользователей
      </Button>
      <Modal open={modalOpened} onClose={() => setModalOpened(false)}>
        <ModalContent>
          <ModalHeader>
            <Typography>Обработка пользователей</Typography>
          </ModalHeader>
          <ModalBody>
            <Stack direction="column" gap={2}>
              {progress && <Typography>{progress}</Typography>}
              {usersData.length > 0 && (
                <Typography>
                  Пользователь {currentRowIndex + 1} из {usersData.length}
                </Typography>
              )}
              {loggedInUser && (
                <Typography style={{ fontStyle: 'italic' }}>
                  Текущий пользователь: {loggedInUser}
                </Typography>
              )}
              {loggedInInn && (
                <Typography style={{ fontStyle: 'italic' }}>
                  ИНН пользователя: {loggedInInn}
                </Typography>
              )}
              {loggedInInn && loggedInUser && (
                <>
                  <InnInput token={DADATA_API_KEY} onSelect={handleInnInput} />
                  {!_.isEmpty(organization) && (
                    <Text color="red">
                      Организация уже зарегистрирована, выберите другую!
                    </Text>
                  )}
                </>
              )}
              {!uploadedFile ? (
                <Button
                  component="label"
                  startIcon={<CloudUpload />}
                  variant="contained"
                >
                  Загрузить Excel файл
                  <VisuallyHiddenInput
                    accept=".xlsx, .xls"
                    type="file"
                    onChange={handleFileSelection}
                  />
                </Button>
              ) : (
                <>
                  {loggedInInn && userSession ? (
                    <>
                      <Button
                        disabled={!organizationForm.inn}
                        style={{
                          backgroundColor: organizationForm.inn
                            ? 'orange'
                            : 'grey',
                          color: 'white',
                        }}
                        onClick={handleContinue}
                      >
                        Создать организацию для пользователя
                      </Button>
                      <Button
                        style={{ backgroundColor: 'red', color: 'white' }}
                        onClick={handleSkip}
                      >
                        Пропустить
                      </Button>
                    </>
                  ) : (
                    <Button
                      disabled={isLoading}
                      style={{
                        backgroundColor: isLoading ? 'grey' : 'blue',
                        color: 'white',
                      }}
                      onClick={handleLogin}
                    >
                      {isLoading ? <CircularProgress size={24} /> : 'Логин'}
                    </Button>
                  )}
                </>
              )}
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ProcessUsers
